<template>
  <div class="w-full pl-16 px-28 py-2">
    <div>
      <RandomText
        class="text-md my-2"
        v-for="(process, index) in process"
        :key="index"
      >
        {{ process.text }}
      </RandomText>
    </div>
    <div class="mt-8">
      <div class="flex" v-for="(info, index) in processInfo" :key="index">
        <RandomText class="text-sm">{{ info.title }}</RandomText>
        <RandomText class="text-sm text-gray-400 pl-1">{{
          info.subtitle
        }}</RandomText>
      </div>
    </div>
  </div>
</template>

<script>
import RandomText from "@/components/RandomText.vue";
export default {
  components: {
    RandomText,
  },
  props: {
    process: {
      type: Array,
      required: true,
    },
    processInfo: {
      type: Array,
      required: true,
    },
  },
};
</script>

